// Copyright (c) Microsoft. All rights reserved.

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState, IMCPTool, ToolState, UserConnectorListResponse, UserConnector } from '../../../libs/models/app/mcp/Tool';
import type { SkillMeta } from '../../../libs/models/app/Skill';

export const ToolSlice = createSlice({
  name: 'tool',
  initialState,
  reducers: {
    setLocalMcpTools: (state: ToolState, action: PayloadAction<Record<string, IMCPTool[]>>) => {
      state.localMcpTools = action.payload;
    },
    setLocalMcpToolState: (state: ToolState, action: PayloadAction<{ tool: string, enabled: boolean }>) => {
      const tool = state.localMcpTools[action.payload.tool.split("__")[0]].find(c => c.name == action.payload.tool);
      if (tool) {
        tool.enabled = action.payload.enabled;
      }
    },
    setConnectors: (state: ToolState, action: PayloadAction<UserConnectorListResponse>) => {
      state.connectors = action.payload;
    },
    setConnector: (state: ToolState, action: PayloadAction<UserConnector>) => {
      console.log(action.payload.id)
      const index = state.connectors.data.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) {
        state.connectors.data[index] = action.payload;
      }
    },
    setSkills: (state: ToolState, action: PayloadAction<SkillMeta[]>) => {
      state.skills = action.payload;
    },
    setSkillEnabled: (state: ToolState, action: PayloadAction<{ skillId: string, enabled: boolean }>) => {
      const skill = state.skills.find((s) => s.id === action.payload.skillId);
      if (skill) {
        skill.enabled = action.payload.enabled;
      }
    }
  },
});

export const { setLocalMcpTools, setLocalMcpToolState, setConnectors, setConnector, setSkills, setSkillEnabled } = ToolSlice.actions;

export default ToolSlice.reducer;
